import type { Starter } from '../Starter'

export const clinicalStarters: Starter[] = [
  {
    id: 'genogram',
    name: 'Genogram',
    description: 'Family · clinical',
    thumbnailUrl: '/assets/images/thumbnails/tb_genogram.svg',
    translationKey: 'templates.names.genogram',
    // Genogram intentionally opens to its in-app use-case picker ("What will
    // you use this genogram for?" — therapy / medical / social work / …),
    // which tailors the lens, templates, and workflow. `template` here is a
    // seedless domain-picker card; the starter catalog does not clone the
    // legacy server template id.
    artifact: { kind: 'template', templateDiagramId: 'mhdb9uhg-2chx7a5nl', diagramType: 'genogram' },
    pickerOnOpen: true,
    job: ['map-family'],
    function: ['clinical'],
    popular: true,
    growsInto: 'clinical',
    collaborative: ['share-view'],
    curatedBy: 'creately',
  },
  {
    id: 'case-intake-genogram',
    name: 'Case Intake Genogram',
    description: 'New-case intake scaffold',
    thumbnailUrl: '/assets/images/thumbnails/tb_genogram.svg',
    artifact: {
      kind: 'agent',
      promptTemplate:
        'Create a three-generation intake genogram scaffold for a new client case: index client, parents, grandparents, one sibling, and a household boundary, with placeholder names ready to edit',
      diagramType: 'genogram',
    },
    job: ['map-family'],
    function: ['clinical'],
    growsInto: 'clinical',
    trigger: 'case-intake',
    collaborative: ['external-review'],
    requiredFlag: 'RDM_ASSISTANT_WRITE',
    curatedBy: 'creately',
  },
  {
    id: 'care-pathway',
    name: 'Care Pathway',
    description: 'Intake to discharge lanes',
    thumbnailUrl: '/assets/images/thumbnails/tb_flowchart.svg',
    artifact: { kind: 'seed', seedId: 'care-pathway', diagramType: 'flowchart' },
    job: ['map-process'],
    function: ['clinical'],
    growsInto: 'clinical',
    collaborative: ['share-view'],
    curatedBy: 'creately',
  },
]
